import { ApiProperty } from '@nestjs/swagger'

export class CountryResponse {
	@ApiProperty({ type: String })
	name: string

	@ApiProperty({ type: String })
	alpha2Code: string

	@ApiProperty({ type: String })
	callingCode: string

	@ApiProperty({ type: String })
	flag: string
}
